import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosAPI from "../../api/axiosAPI";

//============ add brand ===================//
export const addBrand = createAsyncThunk("addBrand", async (data) => {
    try {
        const response = await axiosAPI.post("/add-brand", data)
        return response
    } catch (err) {
        return err
    }
})

//========= Get all brand with pagination ================//
export const getAllBrand = createAsyncThunk("getAllBrand", async ({ page, limit, search }) => {
    try {
        const response = await axiosAPI.get(`/get-all-brand?page=${page}&limit=${limit}&search=${search}`);
        return response;
    } catch (err) {
        return err
    }
});

//=========== Get all brand without pagination ===============//
export const allBrandNoPagination = createAsyncThunk("allBrandNoPagination", async () => {
    try {
        const response = await axiosAPI.get("/get-all-brand");
        return response;
    } catch (err) {
        return err
    }
});

//============== Toggle brand status ==============//
export const toggleBrandStatus = createAsyncThunk("toggleBrandStatus", async (data) => {
    try {
        const { id } = data;
        const response = await axiosAPI.put(`/toggle-brand-status/${id}`);
        return response;
    } catch (err) {
        return err
    }
})

//============ Get single brand ===================//
export const getBrand = createAsyncThunk("getBrand", async (id) => {
    try {
        const response = await axiosAPI.get(`/get-brand/${id}`);
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all brand count ===================//
export const getAllBrandCount = createAsyncThunk("getAllBrandCount", async () => {
    try {
        const response = await axiosAPI.get("/all-brand-count");
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all inactive brand ===================//
export const getInActiveBrand = createAsyncThunk("getInActiveBrand", async () => {
    try {
        const response = await axiosAPI.get("/get-inactive-brand");
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all active brand ===================//
export const getActiveBrand = createAsyncThunk("getActiveBrand", async () => {
    try {
        const response = await axiosAPI.get("/get-active-brand");
        return response;
    } catch (err) {
        return err
    }
});

//=============== update brand =================//
export const updateBrand = createAsyncThunk("updateBrand", async (data) => {
    try {
        const { id, values } = data;
        const response = await axiosAPI.put(`/update-brand/${id}`, values);
        return response
    } catch (err) {
        return err
    }
})